export function rgbToHex(color) {
    return '#' + componentToHex(color.r) + componentToHex(color.g) + componentToHex(color.b);
}

function componentToHex(c) {
    let hex = c.toString(16);
    return hex.length === 1 ? '0' + hex : hex;
}



// WEBPACK FOOTER //
// ./src/app/utils/color-converter.ts